<template>
    <strong class="font-weight-bold">{{ $filters.price(price) }}</strong>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class RoomPriceLabel extends Vue {
        @Prop({required: true}) price
        @Prop() room
    }

    export default RoomPriceLabel
</script>
